class App
{
  constructor ()
  {
    this.cache = new Cache();
    this.session = new Session();
    this.database = new Database();
    this.pregnancyQuotas = new PregnancyQuotas();
    this.hidden = new Hidden();
    this.treatmentCountry = new TreatmentCountry();
    this.strawSets = new StrawSets();
    this.customer = new Customer();
    this.clinics = new Clinics();
    this.notes = new Notes();
    this.waitlist = new Waitlist();
    this.customerImpersonation = new CustomerImpersonation(this);
  }

  init ()
  {
    this.cache.forgetExpired();
    this.database.forgetExpired();
    this.treatmentCountry.init();
    this.strawSets.init();
    this.customer.init();
    this.notes.init();
    this.initTippy();
    this.initGlider();
    this.initAuthRedirect();
  }

  initTippy ()
  {
    document.querySelectorAll('[data-tippy-title]:not(.tippy-initialized)').forEach(div => {
      if (!div.dataset.tippyTitle) {
        div.classList.add('tippy-initialized');

        return;
      }

      let interactive = false;
      const tmp = document.createElement('div');
      tmp.innerHTML = div.dataset.tippyTitle;

      if (tmp.querySelector('a')) {
        interactive = true;
      }

      div.tippyInstance = tippy(div, {
        allowHTML: true,
        interactive: interactive,
        content: div.dataset.tippyTitle
      });

      if (div.tagName.toLowerCase() === 'a' && div.getAttribute('href') === '#') {
        div.addEventListener('click', e => e.preventDefault());
      }

      div.classList.add('tippy-initialized');
    });
  }

  apiUrl (endpoint)
  {
    const apiBase = window.customBackend.url.endsWith('/')
      ? window.customBackend.url
      : window.customBackend.url + '/';
    const path = endpoint.startsWith('/')
      ? endpoint.substring(1)
      : endpoint;

    return apiBase + path;
  }

  apiHeaders ()
  {
    const impersonationId = this.customerImpersonation.getCustomerId();
    const impersonationHash = this.customerImpersonation.getCustomerHash();

    if (impersonationId && impersonationHash) {
      return {
        'Shopify-Customer-Id': impersonationId,
        'Shopify-Customer-Hash': impersonationHash
      }
    }

    if (!window.customBackend.customerHash) {
      return {};
    }

    return {
      'Shopify-Customer-Id': window.customBackend.customerId,
      'Shopify-Customer-Hash': window.customBackend.customerHash
    }
  }

  isApiMockup ()
  {
    if (typeof(window.customBackend.mockup) !== 'undefined') {
      return window.customBackend.mockup;
    }

    return false;
  }

  initGlider ()
  {
    document.querySelectorAll('.glider:not(.glider-initialized)').forEach(slider => {
      slider.glider = new Glider(slider, typeof(slider.dataset.glider) !== 'undefined' ? JSON.parse(slider.dataset.glider) : {

      });

      slider.classList.add('glider-initialized');
    });
  }

  getQueryParamsForCartNotificationSectionsRender ()
  {
    const cartNotification = document.querySelector('cart-notification') || document.querySelector('cart-drawer');

    return 'sections=' + cartNotification.getSectionsToRender().map((section) => section.id).join(',');
  }

  getQueryParamsForCartSectionsRender ()
  {
    const cart = document.querySelector("cart-items");

    return 'sections=' + cart.getSectionsToRender().map((section) => section.id).join(',');
  }

  getCookie (cname)
  {
      let name = cname + "=";
      let decodedCookie = decodeURIComponent(document.cookie);
      let ca = decodedCookie.split(';');

      for (let i = 0; i <ca.length; i++) {
        let c = ca[i];

        while (c.charAt(0) == ' ') {
          c = c.substring(1);
        }

        if (c.indexOf(name) == 0) {
          return c.substring(name.length, c.length);
        }
      }

    return "";
  }

  setCookie (cname, cvalue, exdays = 7)
  {
    const d = new Date();
    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
    let expires = "expires=" + d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
  }

  removeCookie (cname)
  {
    document.cookie = cname + "=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
  }

  initAuthRedirect ()
  {
    const authRedirectUrl = app.session.get('auth_redirect');

    if (!theme.customer
      && window.location.href.indexOf('account/login') === -1
      && window.location.href.indexOf('account/register') === -1
      && window.location.href.indexOf('challenge') === -1
    ) {
      app.session.put('auth_redirect', window.location.href);
    }

    if (window.location.href.indexOf('account/login') === -1 && window.location.href.indexOf('account/register') === -1) {
      document.querySelectorAll('.form-account-login [name="return_to"]').forEach(input => {
        input.value = window.location.href;
      });
    } else {
      // The logged-out collection redirect passes ?return_to= explicitly; prefer it
      // over the sessionStorage copy, which races that redirect (deferred app.js
      // often never runs before the navigation away) and can be stale or missing.
      // Login page only — the register form's return_to is hardcoded for the
      // just_registered flow. Same-site paths only, so the param cannot send the
      // login form off-site.
      const returnToParam = new URLSearchParams(window.location.search).get('return_to');
      const paramTarget = window.location.href.indexOf('account/login') !== -1
        && returnToParam
        && /^\/(?![\/\\])/.test(returnToParam)
          ? returnToParam
          : null;

      if (paramTarget) {
        // Point the post-login safety net below at the same destination, otherwise
        // a stale auth_redirect from an earlier page would bounce the customer away
        // from the return_to target right after logging in.
        app.session.put('auth_redirect', window.location.origin + paramTarget);
      }

      const target = paramTarget || authRedirectUrl;

      if (target) {
        document.querySelectorAll('.form-account-login [name="return_to"]').forEach(input => {
          input.value = target;
        });
      }
    }

    if (theme.customer && authRedirectUrl) {
      app.session.forget('auth_redirect');

      if (window.location.href != authRedirectUrl) {
        console.log('Redirecting to auth URL', authRedirectUrl);

        window.location.href = authRedirectUrl;
      }
    }
  }

  number_format (number, decimals, dec_point, thousands_sep)
  {
    // Strip all characters but numerical ones.
    number = (number + '').replace(/[^0-9+\-Ee.]/g, '');
    var n = !isFinite(+number) ? 0 : +number,
      prec = !isFinite(+decimals) ? 0 : Math.abs(decimals),
      sep = (typeof thousands_sep === 'undefined') ? ',' : thousands_sep,
      dec = (typeof dec_point === 'undefined') ? '.' : dec_point,
      s = '',
      toFixedFix = function (n, prec) {
        var k = Math.pow(10, prec);
        return '' + Math.round(n * k) / k;
      };
    // Fix for IE parseFloat(0.55).toFixed(0) = 0;
    s = (prec ? toFixedFix(n, prec) : '' + Math.round(n)).split('.');
    if (s[0].length > 3) {
      s[0] = s[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, sep);
    }
    if ((s[1] || '').length < prec) {
      s[1] = s[1] || '';
      s[1] += new Array(prec - s[1].length + 1).join('0');
    }
    return s.join(dec);
  }

  money (amount)
  {
    return this.formatMoney(amount, window.theme.shop.money_formatted);
  }

  moneyWithCurrency (amount)
  {
    return this.formatMoney(amount, window.theme.shop.money_formatted_with_currency);
  }

  moneyWithoutTrailingZeros (amount)
  {
    return this.formatMoney(amount, window.theme.shop.money_formatted_without_trailing_zeros, 0);
  }

  formatMoney (amount, format, decimals = 2)
  {
    const decimalPoint = format.substring(format.indexOf('6') + 1, format.indexOf('5'));
    const thousandsSeparator = format.substring(format.indexOf('9') + 1, format.indexOf('8'));
    const formatAmount = format.substring(0, format.indexOf('9')) + '{amount}' + format.substring(format.indexOf('4') + 1);

    return formatAmount.replace('{amount}', this.number_format(parseFloat(amount), decimals, decimalPoint, thousandsSeparator));
  }

  getCountryNameByIsoCode (code)
  {
    const country = window.theme.countries.find(v => v.code.toLowerCase() === code.toLowerCase());

    return country ? country.name : 'Unknown Country';
  }
}

if (!window.app) {
  window.app = new App();

  window.addEventListener('DOMContentLoaded', e => {
    window.app.init();
  });
}